import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Social() {
  const instagramPosts = [{
    eyebrow: "POST 01",
    name: "Instagram",
    description: "Dietro le quinte e processo creativo",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/LOGO-LIONIA-PROJECT.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/LOGO-LIONIA-PROJECT.png",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/LOGO-LIONIA-PROJECT.png",
      alt: "Instagram post showing creative process"
    },
    to: "/HomePage"
  }, {
    eyebrow: "POST 02",
    name: "Instagram",
    description: "Dettagli tecnici e texture",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/20250519_1558_Lioness-at-Dawn_simple_compose_01jvmdbm9fesptmdccdgpy5hgf.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/20250519_1558_Lioness-at-Dawn_simple_compose_01jvmdbm9fesptmdccdgpy5hgf.png",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/20250519_1558_Lioness-at-Dawn_simple_compose_01jvmdbm9fesptmdccdgpy5hgf.png",
      alt: "Instagram post showing technical details"
    },
    to: "/HomePage"
  }, {
    eyebrow: "POST 03",
    name: "Instagram",
    description: "Risultato finale del progetto",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/Post-Instagram-Carosello-Marketing-Aziendale-Minimalista-Moderno-Bianco-A5-orizzontale.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/Post-Instagram-Carosello-Marketing-Aziendale-Minimalista-Moderno-Bianco-A5-orizzontale.png",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/Post-Instagram-Carosello-Marketing-Aziendale-Minimalista-Moderno-Bianco-A5-orizzontale.png",
      alt: "Instagram post showing final result"
    },
    to: "/HomePage"
  }];
  const youtubeVideos = [{
    eyebrow: "VIDEO 01",
    name: "YouTube",
    description: "Tutorial approfonditi e analisi di progetti",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/social_youtube_1.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/social_youtube_1.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/social_youtube_1.png-wvc-sizes",
      alt: "YouTube video thumbnail for tutorial"
    },
    to: "/HomePage"
  }, {
    eyebrow: "VIDEO 02",
    name: "YouTube",
    description: "Case study: Dal concept al lancio",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/social_youtube_2.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/social_youtube_2.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/social_youtube_2.png-wvc-sizes",
      alt: "YouTube video thumbnail for case study"
    },
    to: "/HomePage"
  }];
  return;
}